import { render, staticRenderFns } from "./Main_page.vue?vue&type=template&id=fbb7d332&scoped=true&"
import script from "./Main_page.vue?vue&type=script&lang=js&"
export * from "./Main_page.vue?vue&type=script&lang=js&"
import style0 from "./Main_page.vue?vue&type=style&index=0&id=fbb7d332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb7d332",
  null
  
)

export default component.exports